import script from "./MainPage.vue?vue&type=script&setup=true&lang=js"
export * from "./MainPage.vue?vue&type=script&setup=true&lang=js"

import "./MainPage.vue?vue&type=style&index=0&id=2e329064&lang=css"

const __exports__ = script;

export default __exports__